import classnames from 'classnames';
import { Dayjs } from 'dayjs';
import { useTranslation } from 'react-i18next';

import eventTypeColors from 'src/Utils/eventTypeColors';

import styles from './DayEventRow.module.scss';
import { Props } from './DayEventRow.types';

const DayEventRow = ({ event, locale, onClick }: Props) => {
  const { t } = useTranslation();
  const color = eventTypeColors[event.type]?.bgColor;

  const isMultiDay = Boolean(event.endTime && !event.endTime.isSame(event.startTime, 'day'));

  const formatHour = (d: Dayjs) => d.locale(locale).format('LT');
  const formatDate = (d: Dayjs) => d.locale(locale).format('D MMM');

  let timeLabel: string;
  if (isMultiDay && event.endTime) {
    timeLabel = `${formatDate(event.startTime)} – ${formatDate(event.endTime)}`;
  } else if (event.allDay) {
    timeLabel = t('planning.dayDetail.allDay', 'Toute la journée');
  } else if (event.endTime) {
    timeLabel = `${formatHour(event.startTime)} – ${formatHour(event.endTime)}`;
  } else {
    timeLabel = formatHour(event.startTime);
  }

  const typeLabel = t(`createEventForm.eventTypes.${event.type}`, event.type);

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (onClick && (e.key === 'Enter' || e.key === ' ')) {
      e.preventDefault();
      onClick();
    }
  };

  return (
    <div
      className={classnames(styles.row, { [styles.clickable]: !!onClick })}
      onClick={onClick}
      role={onClick ? 'button' : undefined}
      tabIndex={onClick ? 0 : undefined}
      onKeyDown={handleKeyDown}
    >
      <div className={styles.colorBar} style={{ backgroundColor: color }} />
      <div className={styles.content}>
        <div className={styles.name}>{event.name}</div>
        <div className={styles.meta}>
          <span>{timeLabel}</span>
          <span className={styles.dot}>·</span>
          <span>{typeLabel}</span>
        </div>
      </div>
    </div>
  );
};

export default DayEventRow;
